<template>
  <div class="VirHomePart5">
    <!-- <img class="rightImg" style="left: 0;top: 33%;" v-lazy="$StaticFileUrl + '/mp/img/brief_bag.png'" alt=""/>
    <img class="rightImg" style="right: 0;top: 33%;" v-lazy="$StaticFileUrl + '/mp/img/blief_bag.png'" alt=""/> -->
    <div class="reply_box">
      <div class="reply_content wow animate__fadeInLeft" data-wow-duration="1s">
        <div class="reply_title">使用场景</div>
        <div class="reply_desc">基于海量权益产品 覆盖100+场景解决方案</div>
        <div class="reply_buttom">
          <div
            v-for="(item, index) in VirHomePart5_Data"
            :key="index"
            :class="{ activebox: activeKey === index }"
            @mouseenter="activeKey = index"
          >
            <img
              :src="activeKey === index ? item.selectIcon : item.icon"
              :alt="item.name"
            />
            <div class="headline">{{ item.name }}</div>
          </div>
        </div>
      </div>
      <div class="reply_right">
        <div class="wow animate__fadeInRight" data-wow-duration="1s">
          <div class="reply_head">
            {{ VirHomePart5_Data[activeKey].name }}
          </div>
          <div class="reply_desc">
            {{ VirHomePart5_Data[activeKey].text }}
          </div>
          <div class="reply_more">
            <a href="javascript:void(0)">了解更多 ></a>
          </div>
        </div>
        <img
          :src="VirHomePart5_Data[activeKey].imgUrl"
          class="animate__fadeInRight wow"
          data-wow-duration="1s"
          alt=""
        />
        <div
          class="reply_bg animate__fadeInRight wow"
          data-wow-duration="1s"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * @author  XuHongli
 * @date  2022/12/26 15:28
 * @version 1.0
 * @description
 */
import WOW from "wowjs";
import VirHomePart5_Data from "@/views/ProductServer/VirHome/Data/VirHomePart5_Data";
export default {
  name: "VirHomePart5",
  data() {
    return {
      activeKey: 0,
      VirHomePart5_Data,
    };
  },
  mounted() {
    new WOW.WOW().init();
  },
};
</script>

<style scoped lang="scss">
.VirHomePart5 {
  position: relative;
  width: 100%;
  padding: 120px 0;
  background: #f6f8fa;
}
.reply_box {
  width: 1250px;
  margin: 0 auto;
  padding: 0 0 0 91px;
  display: flex;
  justify-content: space-between;
  .reply_content {
    margin: 60px 76px 0 0;
    width: 400px;
    .reply_title {
      font-size: 44px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei, serif;
      font-weight: 400;
      color: #222;
    }
    .reply_desc {
      line-height: 24px;
      font-size: 18px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei, serif;
      font-weight: 400;
      color: #666;
      margin: 18px 0 60px;
    }
    .reply_buttom {
      display: flex;
      flex-wrap: wrap;
      > .activebox {
        background: #fff;
        box-shadow: 0 3px 29px 1px rgba(99, 99, 99, 0.16);
        cursor: pointer;
        .headline {
          color: #ff6a00;
        }
      }
      > div {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 119px;
        height: 128px;
        .img0 {
          width: 44px;
          height: 37px;
        }
        img {
          margin-bottom: 11px;
        }
        .headline {
          font-size: 18px;
          font-family: Microsoft YaHei-Regular, Microsoft YaHei, serif;
          font-weight: 400;
          color: #222;
        }
      }
    }
  }
}
.reply_right {
  display: flex;
  align-items: center;
  position: relative;
  > div:first-child {
    width: 220px;
    height: 355px;
    background: #fff;
    box-shadow: 0 3px 23px 1px hsla(0, 0%, 41.6%, 0.11);
    margin-top: 90px;
    margin-right: -18px;
    z-index: 99;
    padding: 30px;
    .reply_head {
      font-size: 28px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei, serif;
      font-weight: 400;
      color: #222;
      margin-bottom: 30px;
      position: relative;
      &::after {
        content: "";
        position: absolute;
        left: 0;
        bottom: -8px;
        width: 26px;
        height: 4px;
        background: #ff6a00;
      }
    }
    .reply_desc {
      font-size: 18px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei, serif;
      font-weight: 400;
      color: #666;
      line-height: 28px;
      margin-bottom: 15px;
    }
    .reply_more {
      font-size: 18px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #ff6a00;
      cursor: pointer;
      a {
        display: block;
        width: 100%;
        height: 100%;
        color: inherit;
      }
    }
  }
  img {
    width: 339px;
    height: 653px;
    z-index: 2;
  }
  .reply_bg {
    position: relative;
    display: inline-block;
    padding: 15px;
    color: #fff;
    font-size: 24px;
    width: 196px;
    height: 248px;
    margin-left: -182px;
    margin-bottom: -200px;
    &::before {
      background: #ff6a00;
      z-index: 1;
      position: absolute;
      content: "";
      top: 58px;
      left: -8px;
      right: 0;
      bottom: 0;
      transform: skewY(154deg);
    }
  }
}
</style>
